/**
 * Calculate the total value of pay outs
 * @param data
 * @returns {number}
 * @constructor
 */
const PaidOutTotalValue = (data) => {
  const transactions = data.transactions;

  if (typeof transactions === 'undefined' || transactions.length === 0) return 0;

  let amount = 0;

  transactions.forEach((transaction) => {
    if (transaction.batch[0].completed_at) {
      amount += transaction.amount;
    }
  });

  return amount;
};

export default PaidOutTotalValue;
